import { useState } from "react";
import { MOODS_EMOJI } from "../../constants";

export function StoryCard({ story, onReact }) {
  const [showReactions, setShowReactions] = useState(false);

  return (
    <div className="story-card" data-testid={`story-${story.content_type}-${story.id}`}>
      <div className="story-header">
        <div className="story-user">
          {story.display_picture ? (
            <img src={story.display_picture} alt="" className="story-avatar" />
          ) : (
            <div className="story-avatar story-avatar-placeholder">✨</div>
          )}
          <div className="story-user-info">
            <strong>{story.display_name}</strong>
            <span>{story.content_type === 'wallpaper' ? '🎨 Mood Art' : story.content_type === 'memory' ? '💫 Core Memory' : '💌 Letter'}</span>
          </div>
        </div>
        {story.is_own && <span className="story-own-badge">You</span>}
      </div>

      {story.content_type === 'wallpaper' && (
        <div className="story-wallpaper">
          <img src={`data:image/png;base64,${story.image_base64}`} alt="" />
          <div className="story-wallpaper-overlay">
            <span>{story.mood_emoji} {story.mood}</span>
          </div>
        </div>
      )}

      {story.content_type === 'memory' && (
        <div className="story-memory">
          <div className="memory-orb-small">
            <div className="memory-orb-inner"></div>
          </div>
          <div className="story-memory-content">
            <h4>{story.title}</h4>
            <p>{story.summary}</p>
            <div className="memory-card-meta">
              <span className="memory-mood">{story.mood_at_time} {MOODS_EMOJI[story.mood_at_time] || '✨'}</span>
              <span className="memory-stars">
                {[...Array(Math.round((story.importance || 0.5) * 5))].map((_, i) => (
                  <span key={i}>✦</span>
                ))}
              </span>
            </div>
          </div>
        </div>
      )}

      {story.content_type === 'letter' && (
        <div className="story-letter">
          <div className="story-letter-icon">💌</div>
          <h4>{story.title}</h4>
          <p className="story-letter-period">{story.period_label}</p>
          <p className="story-letter-preview">{story.body?.substring(0, 200)}...</p>
          {story.moods_summary && story.moods_summary.length > 0 && (
            <div className="letter-moods-list">
              {story.moods_summary.slice(0, 3).map((mood, i) => (
                <span key={i} className="letter-mood-pill">{mood} {MOODS_EMOJI[mood] || '✨'}</span>
              ))}
            </div>
          )}
        </div>
      )}

      <div className="story-actions">
        <button
          className={`story-react-btn ${story.user_reaction ? 'reacted' : ''}`}
          onClick={() => setShowReactions(!showReactions)}
          data-testid={`react-btn-${story.id}`}
        >
          {story.user_reaction ? `${MOODS_EMOJI[story.user_reaction] || '✨'} Resonated` : '✨ Resonate'}
        </button>
        <span className="story-loves">{story.total_loves || 0} {story.total_loves === 1 ? 'resonance' : 'resonances'}</span>
      </div>

      {showReactions && (
        <div className="story-reactions-picker">
          {Object.entries(MOODS_EMOJI).map(([mood, emoji]) => (
            <button
              key={mood}
              className={`reaction-pick ${story.user_reaction === mood ? 'active' : ''}`}
              onClick={() => { onReact(story, mood); setShowReactions(false); }}
              data-testid={`reaction-${mood}-${story.id}`}
              title={mood}
            >
              {emoji}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
